import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { ProductBadge } from 'src/app/core/interfaces/store-configuration.interface';

@Component({
  standalone: true,
  selector: 'webstore-product-badge',
  templateUrl: './product-badge.component.html',
  styleUrls: ['./product-badge.component.scss'],
  imports: [CommonModule]
})
export class ProductBadgeComponent {

  isDesc = false;



  readonly badgesInput = input<ProductBadge[]>([]);

  get badges(): ProductBadge[] {
    return this.badgesInput();
  }

  onSwitchMode() {
    this.isDesc = !this.isDesc;
  }


}

